import { Controller } from '@hotwired/stimulus'
import { useMeta, useTransition } from 'stimulus-use'
import { createPopper } from '@popperjs/core';
import { leave, enter } from '@/el-transition'
import Dropzone from "dropzone"
import { client } from "@/axios"

Dropzone.autoDiscover = false

export default class extends Controller {
    static targets = [
        'input',
        'file',
    ]

    connect() {}
    disconnect() {}
}